import React, {useState} from 'react'
import { SlDrawer } from '@shoelace-style/shoelace/dist/react'
import BirdViewData from './BirdViewData';
import { roles } from '../../utils/constants';
import ReportBirdview from './ReportBirdview';
function B2BPreview(props) {
  const [open, setOpen] = useState(false)
  const [showReport, setShowReport] = useState(false)
      const [reportId, setReportId] = useState(0)
      const [imageUrl, setImageUrl] = useState()
  return (
    <>
    <SlDrawer  open={props.show}  onSlRequestClose={(e) => {
    // ONLY close if the event came from this specific drawer
    // e.target refers to the element that triggered the event
    if (e.target !== e.currentTarget) {
      return; 
    }
     if (e.detail.source !== "overlay") {
       props.setShow(false);
      }
      e.preventDefault();
  }} style={{ "--size": window.innerWidth >= 767 ? '50%': "100%" }}>
        <BirdViewData brand={props.brand} language={props.language}  date={props.date} from="market" newspaper={props.newspaper} salesPerson_id={props.salesPerson_id} fetchW2n={props.fetchW2n} fetchAllNews={props.fetchAllNews} fetchW2nCampaign_type={props.fetchW2nCampaign_type}  setOpen={setOpen} setReportId={setReportId} setImageUrl={setImageUrl} setShowReport={setShowReport}/>
       
    </SlDrawer>
       <ReportBirdview open={showReport} setOpen={setShowReport} reportId={reportId} image_url={imageUrl}/>
    
    </>
  )
}

export default B2BPreview